/**
 * @module app.bdc.reports.sepaLiasseNapCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function SepaLiasseNapCtrl($scope, $window, $rootScope) {
        var self = {};
        self.client = $rootScope.order.client;
        self.sepaType;
        var emptyIBAN = ['F', 'R'];
        self.IBAN = self.client.IBAN
            ? self.client.IBAN.split('')
            : Array.apply(null, Array(27)).map(function(element, index) {
                return index == 0 || index == 1 ? emptyIBAN[index] : '\u200E';
            }); // Return array with a length of 27 starting with FR and then special spaces
        self.codeBic = self.client.codeBic
            ? self.client.codeBic.split('')
            : Array.apply(null, Array(11)).map(function() {
                return '\u200E';
            });

        self.getInfo = (type) => {
            if(type === 'BURALOG'){
                return {
                    idSepa :  'FR83ZZZ514168'.split(''),
                    companyFooter :
                        'SAS au capital de 85 800 euros - Siret : 491 286 753 000 42 - APE 4651 Z - TVA : FR 76 491 286 753'
                };
            }
            if(type === 'SRD'){
                return {
                    idSepa :  'FR33ZZZ520597'.split(''),
                    companyFooter :
                        'SAS au capital de 300 000 euros - Siret : 492 300 520 - APE 4652 Z - TVA : FR 39 492 300 520'
                };
            }
            if(type === 'SRD MP'){
                return {
                    idSepa :  'FR94ZZZ564992'.split(''),
                    companyFooter :
                        'SAS au capital de 10 000 euros - Siret : 517 485 017 - APE 4651 Z - TVA : FR 36 517 485 017'
                };
            }
        };

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Generate the unique sepa report identifier
         * 3 letters lastName + 3 letters firstName + date : YYYYMMDD + postal code + sepa type
         * @return {String}
         */
        self.getNumero = function getNumero() {
            var num = '';

            num += self.client.lastName.slice(0, 3).toUpperCase();
            num += self.client.firstName.slice(0, 3).toUpperCase();
            num += moment().format('YYYYMMDD');
            num += self.client.addressPostalCode;

            if (self.sepaType === 'SRD MP') {
                return num + 'SMP';
            }

            return num + self.sepaType.slice(0, 3);
        };
        // Modification du title de la page pour l"impression en PDF
        $window.document.title =
            self.client.lastName +
            '_' +
            self.client.firstName +
            '_' +
            'Liasse_NAP' +
            '_' +
            moment().format('YYYYMMDD');

        return self;
    }

    SepaLiasseNapCtrl.$inject = ['$scope', '$window', '$rootScope'];

    angular.module('app.bdc.reports.sepaLiasseNapCtrl', []).controller('SepaLiasseNapCtrl', SepaLiasseNapCtrl);

    return SepaLiasseNapCtrl;
});
